import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Config } from "./config.model";
import { LogService } from "./log.service";
import { ErrorHandlerService } from "./error-handler.service";
import { ErrorHandlerUnauthorizedService } from './error-handler-unauthorized.service';
declare function OTHHUrlBuilder(options: { product: string, version: string, urlRoot: string }): any;

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  /**
   * Public Configuration Information
  **/
  private _configuration: Config | undefined;
  /**
   * Configuration exposed as an observavble - watchers will be informed when configuration is updated
   * Configuration is updated by either header or loging forms.
   */
  configLoaded$ = new Subject<Config>();

  /**
   * Help page URL
   */
  helpUrl = new Subject<string>();

  /** 
   * Configuration constructor
   * @param http used to make http call get the information from the json config file
   * @param error handle errors
   * @param log log errors
   */

  constructor(private http: HttpClient, private error: ErrorHandlerService,
    private log: LogService, private unauthorized: ErrorHandlerUnauthorizedService) {
  }

  /**
   * Configurations getter and setter.  setter also fires the configuration observable
   */
  public get configuration(): Config | undefined {
    return this._configuration;
  }
  public set configuration(config: Config | undefined) {
    if (config != undefined) {
      this._configuration = config;
      this.log.setConfiguration(this._configuration);
      this.configLoaded$.next(this._configuration);
    }
    else
      console.log("config.service : set configuration - undefined")
  }

  /**
   * Load the confgiruraqtion from the server assets directory
   */
  loadConfig(): Observable<{} | Config> {
    this.log.logMessage("loadConfig()");

    //
    // Define the http get request. It will not execute until .subscribe() is called.
    //
    return this.http.get<Config>('assets/config/appConfig.json').pipe(catchError(err => {
      if (this.unauthorized.handleError(err))
        return of([]);
      return this.error.handleError(err);
    }));
  }

  /**
   * Load the system information
   */
  loadSystemInfo() {
    this.log.logMessage('loadSystemInfo()');

    //
    // Define the http get request. It will not execute until .subscribe() is called.
    //
    return this.http.get('3rdpartylicenses.txt', { responseType: 'text' }).pipe(catchError(err => {
      if (this.unauthorized.handleError(err))
        return of([]);
      return this.error.handleError(err);
    }));
  }

  /**
   * Set the help URL
   * 
   * @param page the help page to load when Help is invoked
   */
  setHelpUrl(page: string) {

    this.log.logMessage(`setHelpUrl()`);

    if (this._configuration != undefined) {
      const othh = OTHHUrlBuilder({
        product: 'fret',
        version: '9.0.2',
        // URL fetched from the app.config file
        urlRoot: this._configuration.helpURL
      });

      this.log.logMessage(`setHelpUrl() ${page}`);

      const locale = "en_US";
      this.helpUrl.next(othh.buildHelpUrl(locale, page));
    }
  }
}